import { useCallback, useEffect, useMemo, useState } from "react";

import IconButton from "../reusable/icon-button";
import UserIcon from "../reusable/userIcon";

import EditIcon from "../icons/miscs/Edit";
import PN from "../../assets/images/pn.svg";

import { useAppSelector } from "../../hooks/redux";
import { useAppDispatch } from "../../hooks/redux";
import { setUpdateQuery } from "../../stores/know-now";
import sanitizeHtml from "sanitize-html";
import ToolTip from "../reusable/tool-tip";
import ArrowDown from "../icons/miscs/ArrowDown";
import ArrowUp from "../icons/miscs/ArrowUp";
import Modal from "../reusable/modal";
import remarkGfm from "remark-gfm";
import Markdown from "react-markdown";
import rehypeExternalLinks from "rehype-external-links";
import { Switch } from "@headlessui/react";
import SourcesData from "src/pages/product/ai-agent/DataSources";
import TemplateReport from "src/pages/product/ai-agent/ReportTemplate";
import { getTimeCurrent } from "src/utils/helpers";
import pdot from "src/assets/images/icons/p-dot.svg";
import blinkSpinner from "src/assets/images/icons/blink-spinner.svg";
import addicon from "src/assets/images/icons/addbutton.svg";
import checkIcon from "src/pages/product/ai-agent/_assets/checkIcon.svg";

import PrimaryButton from "../reusable/button/primary-button";
import classNames from "classnames";
import Keywords from "src/pages/product/ai-agent/Keywords";
import CampaignTemplateReport from "src/pages/product/ai-agent/CampaignTemplateReport";

// interface IChat {
//   query: string;
//   answer: string;
// }

interface Props {
  query: string;
  updateQuery?: (query: string, editIndex: number) => void;
  chatIndex?: any;
  setEditIndex?: any;
  editIndex?: any;
  setQuery?: any;
  isloadingCompleted?: boolean;
  shouldStream?: boolean;
  json_report?: any;
  additionalJsonReport?: any;
  dataSource?: any;
  additionalDataSources?: any;
  index?: number;
  initLoading?: boolean;
  agentName?: string;
  isError?: boolean;
  retry?: () => void;
  keywords?: string[];
  updateUserInput?: (value: string) => void;
  answer?: string;
}

const ChatQuery = ({
  query,
  updateQuery,
  editIndex,
  isloadingCompleted,
  additionalJsonReport,
  shouldStream = true,
  json_report,
  dataSource,
  index,
  initLoading,
  agentName,
  isError,
  additionalDataSources,
  retry = () => {
    undefined;
  },
  keywords,
  updateUserInput = () => {
    undefined;
  },
  answer,
}: Props) => {
  const dispatch = useAppDispatch();

  const userDetail = useAppSelector((state) => state.auth.user);
  const [edit, setEdit] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const onEdit = useCallback(() => {
    setEdit(true);
    dispatch(setUpdateQuery({ editIndex: editIndex, query: "" }));
  }, [dispatch, editIndex]);

  const onCancel = useCallback(() => {
    setEdit(false);
    dispatch(setUpdateQuery({ editIndex: null, query: "" }));
  }, [dispatch]);

  const onHide = useCallback(() => {
    setShowMore((prev) => !prev);
  }, []);

  const formattedQuery = query.replace(/\n/g, "<br>");

  const sanitizedQuery = sanitizeHtml(formattedQuery, {
    allowedTags: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "br",
      "p",
      "table",
      "thead",
      "tbody",
      "tr",
      "th",
      "td",
    ],
    allowedAttributes: {
      a: ["href"],
    },
  });


  function isMore(query: string) {
    const words = query.trim().split(/\s+/);
    return words.length > 50;
  }

  const [modalOpen, setModalOpen] = useState({
    status: false,
    type: "",
  });

  const [keywordModal, setKeywordModal]
    = useState(false)
  const handleModalClose = () => {
    setModalOpen({
      status: false,
      type: "",
    });
  };
  const { beforeText, options, afterText } = useMemo(() => {
    const message = query || "";
    const optionRegex = /@@@(.*?)@@@/gs;

    const options: string[] = [];
    let match;
    const indices = [];

    while ((match = optionRegex.exec(message)) !== null) {
      const block = match[1].trim();

      // ✅ FIX: handle multi-line vs single-line
      if (block.includes("\n")) {
        block
          .split(/\r?\n/) // split by line breaks
          .map(l => l.trim())
          .filter(Boolean)
          .forEach(line => options.push(line));
      } else {
        options.push(block);
      }

      indices.push({ start: match.index, end: optionRegex.lastIndex });
    }

    if (indices.length === 0) {
      return {
        beforeText: message.trim(),
        options: [],
        afterText: "",
      };
    }

    const beforeText = message.slice(0, indices[0].start).trim();
    const afterText = message.slice(indices[indices.length - 1].end).trim();

    return {
      beforeText,
      options,
      afterText,
    };
  }, [query]);

  // console.log("options", options);


  const [selectedQueryOptions, setSelectedQueryOptions] = useState<string[]>([])

  const handleAdd = (option: string) => {
    if (agentName === "Customer 360 Agent" && index === -1) {
      setSelectedQueryOptions([option]);
    }
    else {
      setSelectedQueryOptions([...selectedQueryOptions, option]);
    }
    if (!answer?.trim() || (agentName === "Customer 360 Agent" && index === -1)) {
      updateUserInput(option);
    } else {
      updateUserInput(`${answer}, ${option}`);
    }
  };

  const handleDelete = (optionToRemove: string) => {
    // Remove from selected options
    const updatedOptions = selectedQueryOptions.filter(opt => opt !== optionToRemove);
    setSelectedQueryOptions(updatedOptions);

    // Remove from combined string (answer)
    const regex = new RegExp(`(^|, )${optionToRemove}(, )?|(^| )${optionToRemove}$`, 'g');
    const cleanedAnswer = (answer || "").replace(regex, '').replace(/(^, )|(, $)/, '').trim();
    updateUserInput(cleanedAnswer);
  };
  const parsedBlocks = useMemo<any[]>(() => {
    if (agentName !== "Report Anything Agent") {
      return [{ type: "markdown", content: query }];
    }

    const blocks: any[] = [];
    const optionRegex = /@@@([\s\S]*?)@@@/g;

    let lastIndex = 0;
    let match;

    while ((match = optionRegex.exec(query)) !== null) {
      // markdown before option
      if (match.index > lastIndex) {
        const markdown = query.slice(lastIndex, match.index);
        if (markdown.trim()) {
          blocks.push({
            type: "markdown",
            content: markdown,
          });
        }
      }

      // extract option text
      const inner = match[1].trim();

      inner
        .split(/\r?\n/)
        .map(l => l.trim())
        .filter(Boolean)
        .forEach(option => {
          blocks.push({
            type: "option",
            value: option,
          });
        });

      lastIndex = optionRegex.lastIndex;
    }

    // remaining markdown
    if (lastIndex < query.length) {
      const rest = query.slice(lastIndex);
      if (rest.trim()) {
        blocks.push({
          type: "markdown",
          content: rest,
        });
      }
    }

    return blocks;
  }, [query, agentName]);

  if (!query) return <></>;



  return (
    <div className="flex items-center justify-start gap-2">
      <div className="pt-3 shrink-0 ">
        <img className="h-3 w-3 " src={PN} alt={"Pn"} />
      </div>
      <div
        className={`shadow-md border border-gray-200 bg-white mb-2 ${isError ? "bg-red-200" : ""} ${index === 0 ? "" : "mt-2"
          } rounded-2xl rounded-bl-none flex items-center justify-center px-4 py-2 gap-2 relative  `}
      >
        {/* <div
          className={`text-secondary-800 text-justify ${showMore ? "" : ""}`}
          dangerouslySetInnerHTML={{ __html: sanitizedQuery }}
        /> */}
        {(index === 0 || (agentName === "Customer 360 Agent" && index === 5)) ? (
          <div className=" w-full">
            {/* Header */}
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-1">
                <img src={pdot} alt={"Pn"} className="h-4 w-4 " />
                <h2 className="text-gray-900 font-semibold">{agentName}</h2>
              </div>
              <span className="relative before:content-[''] before:absolute before:left-0 before:top-0 before:w-[2px] before:h-full before:bg-gray-200 before:mr-2 pl-2 text-gray-400 text-sm">
                {getTimeCurrent()}
              </span>
            </div>
            <hr className="border-gray-300 my-1"></hr>

            {/* Status Indicator */}

            {initLoading ? (
              <div className="flex items-center space-x-2 bg-primary-900  text-white px-3 py-1 rounded-full w-fit mb-3 mt-2">
                <span>Thinking</span>
                <img
                  style={{ animation: "spin 2s linear infinite" }}
                  className=""
                  src={blinkSpinner}
                  alt={"Pn"}
                />
              </div>
            ) : null}
            <>


              {agentName === "Report Anything Agent" ? (
                parsedBlocks.map((block, idx) => {
                  if (block.type === "markdown" || block.type === "heading") {
                    return (
                      <Markdown
                        key={idx}
                        className="markdownWrapper text-secondary-800"
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[
                          [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                        ]}
                      >
                        {block.content}
                      </Markdown>
                    );
                  }

                  if (block.type === "option") {
                    const selected = selectedQueryOptions.includes(block.value);

                    return (
                      <button
                        key={idx}
                        onClick={() =>
                          selected
                            ? handleDelete(block.value)
                            : handleAdd(block.value)
                        }
                        className={classNames(
                          "w-full text-sm rounded-lg py-1 px-2 border flex justify-between items-center my-1",
                          selected
                            ? "bg-foundationOrange-100 border-secondary-500"
                            : "border-secondary-500 hover:bg-foundationOrange-100"
                        )}
                      >
                        {block.value}
                        <img src={selected ? checkIcon : addicon} alt="add" />
                      </button>
                    );
                  }

                  return null;
                })
              ) :
                <>
                  <Markdown
                    className="markdownWrapper text-secondary-800 text-align relative "
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                    ]}
                  >

                    {beforeText}


                  </Markdown>
                  {options?.length ?
                    <div className="relative ">
                      <div className={`flex flex-wrap items-center gap-1 my-1`}>
                        {options.map((option: string) => (
                          <>
                            <button
                              key={index}
                              onClick={() => selectedQueryOptions.includes(option) ? handleDelete(option) : handleAdd(option)}
                              // onClick={() => {
                              // }}
                              // disabled={stage !== "Edit Summary" ? hasselected : false}
                              className={`${selectedQueryOptions.includes(option) ? "bg-foundationOrange-100 border-secondary-500" : ""} w-full cursor-pointer text-sm rounded-lg py-1 px-2 border border-secondary-500 hover:bg-foundationOrange-100 text-secondary-800 flex justify-between gap-2 items-center`}
                            >
                              {option}
                              <img
                                className=""
                                src={selectedQueryOptions.includes(option) ? checkIcon : addicon}
                                alt={"add"}
                              />
                            </button>
                          </>
                        ))}
                      </div>
                    </div> : null}
                  {afterText ? <Markdown
                    className="markdownWrapper text-secondary-800 text-align relative "
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                    ]}
                  >

                    {afterText}


                  </Markdown>

                    : null}
                </>
              }
            </>
          </div>
        ) : isError ? (
          <div className="flex items-center justify-center gap-2">
            <p>{query}</p>
            <button
              onClick={retry}
              className={classNames(
                "disabled:cursor-not-allowed flex items-center justify-center gap-2 px-4 py-1 font-600 hover:shado hover:scale-[1.03] duration-500 rounded-full  text-secondary-400 border border-secondary-400 hover:bg-secondary-400 hover:text-white  border-primary-900",
              )}
            >
              Retry
            </button>
          </div>
        ) : (
          <>

            <div className=" w-full">
              {agentName === "Report Anything Agent" ? (
                parsedBlocks.map((block, idx) => {
                  if (block.type === "markdown" || block.type === "heading") {
                    return (
                      <Markdown
                        key={idx}
                        className="markdownWrapper text-secondary-800"
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[
                          [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                        ]}
                      >
                        {block.content}
                      </Markdown>
                    );
                  }

                  if (block.type === "option") {
                    const selected = selectedQueryOptions.includes(block.value);

                    return (
                      <button
                        key={idx}
                        onClick={() =>
                          selected
                            ? handleDelete(block.value)
                            : handleAdd(block.value)
                        }
                        className={classNames(
                          "w-full text-sm rounded-lg py-1 px-2 border flex justify-between items-center my-1",
                          selected
                            ? "bg-foundationOrange-100 border-secondary-500"
                            : "border-secondary-500 hover:bg-foundationOrange-100"
                        )}
                      >
                        {block.value}
                        <img src={selected ? checkIcon : addicon} alt="add" />
                      </button>
                    );
                  }

                  return null;
                })
              ) :
                <>
                  <Markdown
                    className="markdownWrapper text-secondary-800 text-align relative "
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                    ]}
                  >

                    {beforeText}


                  </Markdown>
                  {options?.length ?
                    <div className="relative ">
                      <div className={`flex flex-wrap items-center gap-1 my-1`}>
                        {options.map((option: string) => (
                          <>
                            <button
                              key={index}
                              onClick={() => selectedQueryOptions.includes(option) ? handleDelete(option) : handleAdd(option)}
                              // onClick={() => {
                              // }}
                              // disabled={stage !== "Edit Summary" ? hasselected : false}
                              className={`${selectedQueryOptions.includes(option) ? "bg-foundationOrange-100 border-secondary-500" : ""} w-full cursor-pointer text-sm rounded-lg py-1 px-2 border border-secondary-500 hover:bg-foundationOrange-100 text-secondary-800 flex justify-between gap-2 items-center`}
                            >
                              {option}
                              <img
                                className=""
                                src={selectedQueryOptions.includes(option) ? checkIcon : addicon}
                                alt={"add"}
                              />
                            </button>
                          </>
                        ))}
                      </div>
                    </div> : null}
                  {afterText ? <Markdown
                    className="markdownWrapper text-secondary-800 text-align relative "
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[
                      [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                    ]}
                  >

                    {afterText}


                  </Markdown> : null}
                </>
              }
            </div>
          </>
        )}
      </div>
      {keywords?.length ? <div className="font-semibold text-md text-end">
        <Switch
          checked={true}
          onChange={() => {
            setKeywordModal(true)
          }}
          className={`border border-appGray-500 relative inline-flex items-center h-2 rounded-full w-4 mr-1`}
        >
          <span
            className={`translate-x-0 inline-block w-[12px] h-[12px] transform bg-appGray-500 rounded-full`}
          />
        </Switch>Keywords</div> : null}
      {Object.keys(json_report || {}).length || Object.keys(dataSource || {}).length ? (
        <div className="font-semibold text-md text-end">
          <Switch
            checked={true}
            onChange={() => {
              setModalOpen({
                status: true,
                type: "normal",
              });
            }}
            className={`border border-appGray-500 relative inline-flex items-center h-2 rounded-full w-4 mr-1`}
          >
            <span
              className={`translate-x-0 inline-block w-[12px] h-[12px] transform bg-appGray-500 rounded-full`}
            />
          </Switch>
          {Object.keys(json_report || {}).length ? "Report Template" : "Data Sources"}
        </div>
      ) : null}
      {Object.keys(additionalDataSources || {}).length ||
        Object.keys(additionalJsonReport || {}).length ? (
        <div className="font-semibold text-md text-end">
          <Switch
            checked={true}
            onChange={() => {
              setModalOpen({
                status: true,
                type: "additional",
              });
            }}
            className={`border border-appGray-500 relative inline-flex items-center h-2 rounded-full w-4 mr-1`}
          >
            <span
              className={`translate-x-0 inline-block w-[12px] h-[12px] transform bg-appGray-500 rounded-full`}
            />
          </Switch>
          {Object.keys(additionalDataSources || {}).length
            ? "Custom Data Sources"
            : "Custom Report Template"}
        </div>
      ) : null}
      <Modal width="mx-auto" open={modalOpen.status || keywordModal} handleOnClose={handleModalClose}>
        <div className="bg-foundationOrange-100 p-4 border border-secondary-500 mx-auto rounded-lg h-[90vh] overflow-y-auto pn_scroller">
          <div className="font-bold text-md text-end">
            <Switch
              checked={true}
              onChange={() => {
                setKeywordModal(false)
                setModalOpen({
                  status: false,
                  type: "",
                });
              }}
              className={`bg-primary-900 relative inline-flex items-center h-2 rounded-full w-4 mr-1 mb-2`}
            >
              <span
                className={`translate-x-2 inline-block w-2 h-2 transform bg-white rounded-full`}
              />
            </Switch>
            {keywordModal ? "Keywords" : Object.keys(json_report || {}).length ? "Report Template" : "Data Sources"}
          </div>
          {keywordModal && keywords?.length ? <Keywords dataSource={keywords} disabled /> :
            <>
              {modalOpen.type === "normal" ? (
                <>
                  {Object.keys(json_report || {}).length ? (
                    <div className="mx-auto justify-center flex">
                      {
                        json_report.sections ?
                          <TemplateReport reportSummary={json_report.sections} disabled />
                          : <CampaignTemplateReport campaignData={json_report} />
                      }
                    </div>
                  ) : null}

                  {Object.keys(dataSource || {}).length ? (
                    <div className="mx-auto justify-center flex">
                      <SourcesData dataSource={dataSource} disabled />
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  {Object.keys(additionalJsonReport || {}).length ? (
                    <div className="mx-auto justify-center flex">
                      <TemplateReport reportSummary={additionalJsonReport} disabled />
                    </div>
                  ) : null}
                  {Object.keys(additionalDataSources || {}).length ? (
                    <div className="mx-auto justify-center flex">
                      <SourcesData dataSource={additionalDataSources} disabled />
                    </div>
                  ) : null}
                </>
              )}
            </>
          }
        </div>
      </Modal>
    </div>
  );
};

export default ChatQuery;
